import { REVENUE_CHART_CARD_SHADOW } from "../revenue/constants";

export const OVERVIEW_CARD_CLASSNAME = [
  "rounded-2xl border border-[#E5E5E5] bg-white p-4",
  REVENUE_CHART_CARD_SHADOW,
].join(" ");

/** Figma: Charts / Bar Chart / Rectangle */
export const FLOW_COMPLETION_BAR_HEIGHT_PX = 40;
export const FLOW_COMPLETION_BAR_TRACK_COLOR = "#E9E9E9";
export const FLOW_COMPLETION_BAR_FILL_GRADIENT =
  "linear-gradient(90deg, #CDC9BB 0%, #CDC9BB 100%)";
export const FLOW_COMPLETION_BAR_FILL_OPACITY = 0.8;
